import React from 'react';

/**
 * 사이드바 — 메뉴 전용 (2026-09-21)
 *
 * 예전에는 로고·버전·시계·날씨·사용자·비밀번호 변경이 전부 여기 들어 있어
 * 메뉴가 화면 아래로 밀렸다. VIMS 와 같은 형태로 그 정보들을 상단 바(TopBar.js)로
 * 옮기고, 여기에는 메뉴만 남겼다.
 */
const Sidebar = ({ user, menus, onMenuClick }) => {
  if (!menus || !user) return null;

  // 사용자 등급(Role)에 맞는 메뉴만 필터링 (menuConfig.js 기준)
  const allowedMenus = menus.filter(menu => menu.roles.includes(user.role));

  const styles = {
    wrapper: {
      width: '240px', background: '#243447', color: '#ffffff', height: '100%',
      padding: '14px 20px 30px', display: 'flex', flexDirection: 'column',
      boxSizing: 'border-box', fontFamily: 'sans-serif', overflowY: 'auto'
    },
    menuList: { listStyle: 'none', padding: 0, margin: 0 },
    menuItem: {
      padding: '13px 10px', color: '#cbd5e1', cursor: 'pointer', display: 'flex',
      alignItems: 'center', gap: '15px', fontSize: '15px', transition: '0.2s', borderRadius: '8px'
    },
    menuArrow: { fontSize: '8px', color: '#64748b' }
  };

  return (
    <div style={styles.wrapper}>
      <nav style={{ flex: 1 }}>
        <ul style={styles.menuList}>
          {allowedMenus.map(menu => (
            <li
              key={menu.id}
              onClick={() => onMenuClick(menu.id)}
              style={styles.menuItem}
              onMouseOver={(e) => {
                e.currentTarget.style.color = '#ffffff';
                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.color = '#cbd5e1';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <span style={styles.menuArrow}>▶</span> {menu.title}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
